export const selectSurgicalHistory = (state) => state.surgicalHistory;
export const selectSurgicalData = (state) => state.surgicalHistory.data;
export const selectSurgicalLoading = (state) => state.surgicalHistory.loading;
export const selectSurgicalError = (state) => state.surgicalHistory.error;